// extracted by mini-css-extract-plugin
module.exports = {"card":"cityCard_card__3vcMO","icon":"cityCard_icon__CdkcG","name":"cityCard_name__2knWa"};